import { List } from "@material-ui/core";
import React from "react";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { eventLabelGroupsConstants } from "../../../constants/eventLabelGroups.contansts";
import { ScrollWrapper } from "../../../helpers/module.helper";
import { AgendaItem } from "./AgendaItem";
import { AgendaTextWrapper } from "./AgendaTextWrapper";
import { Speaker } from "./Speaker";
import { combineProps } from "../../../../helpers/objectHelper";

export function AgendaContainer(props) {
  const {
    getAgendaStyle,
    speakers,
    agenda,
    isAllowedSpeaker,
    isAuthorizedSpeaker,
    hasRequestedTheFloor,
    requestTheFloor,
    unassignRequest,
    template,
    clientKey,
    isSpeakerActive,
    allowSpeaker,

    agendaListRef,
    activeAgendaRef,
    settings,
  } = props;
  const collapsibleAgenda = typeof settings.collapsibleAgenda != "undefined" ? settings.collapsibleAgenda : props.collapsibleAgenda;
  const { hideSubtitle, hideTitle, hideSpeaker } = settings;

  return (
    <div
      style={{
        ...getAgendaStyle("Content", "DEFAULT"),
        display: "flex",
        flexDirection: "column",
      }}
    >
      {hideSpeaker != true ? <Speaker {...props} /> : null}
      {hideTitle != true ? (
        <div style={getAgendaStyle("Title", "DEFAULT")}>
          <EventLabel2 name="Agenda" groupName={eventLabelGroupsConstants.AGENDA_LABEL_GROUP} />
        </div>
      ) : null}
      {hideSubtitle != true ? (
        <div style={getAgendaStyle("Subtitle", "DEFAULT")}>
          <EventLabel2 name="AgendaDescription" groupName={eventLabelGroupsConstants.AGENDA_LABEL_GROUP} />
        </div>
      ) : null}
      <ScrollWrapper {...combineProps([props, { noStyleWrap: true }])}>
        <List className="jir-scroll" style={{ height: "100%", overflow: "hidden auto" }}>
          {agenda
            .filter((a) => a.hidden != true)
            .map((a, i) => {
              let bgColor = template ? template.content.backgroundColor : undefined;
              if (a.closedDateTime !== null && template) {
                bgColor = template.tcell.borderColor;
              }
              let status = a.active ? "ACTIVE" : a.closedDateTime !== null ? "PASSED" : "DEFAULT";
              let showSpeakerControl = isAuthorizedSpeaker() && allowSpeaker === true && isAllowedSpeaker() && a.closedDateTime == null;
              return (
                <div key={i} ref={(r) => (status == "ACTIVE" ? (activeAgendaRef.current = r) : undefined)}>
                  <AgendaItem
                    rowStyle={getAgendaStyle("RowFrame", status)}
                    titleStyle={getAgendaStyle("RowTitle", status)}
                    textStyle={getAgendaStyle("RowText", status)}
                    styleWrapper={<AgendaTextWrapper {...combineProps([status, props])} />}
                    clientKey={clientKey}
                    title={a.name}
                    text={a.text}
                    collapsible={collapsibleAgenda}
                    showSpeakerControl={showSpeakerControl}
                    status={status}
                    closed={status == "PASSED"}
                    active={status == "ACTIVE"}
                    hasRequestedTheFloor={showSpeakerControl ? hasRequestedTheFloor(a.agendaItemId) : false}
                    requestPointOfOrder={() => requestTheFloor(a.agendaItemId, 3, null)}
                    isSpeakerActive={showSpeakerControl ? isSpeakerActive(a.agendaItemId) : false}
                    requestTheFloor={() => requestTheFloor(a.agendaItemId, 1, null)}
                    orderId={props.orderId}
                    settings={settings}
                    unassignRequest={() => unassignRequest(a.agendaItemId)}
                    template={props.template}
                  />
                </div>
              );
            })}
        </List>
      </ScrollWrapper>
    </div>
  );
}
